import ResultController from './result.controller';
import template from './result.html';
import './result.less';

const ResultComponent = {
  bindings: {
    expert: '<',
    showDistanceFromPostcode: '<',
    selectedSolutions: '<',
    coverageStates: '<'
  },
  template,
  controller: ResultController
};

export default ResultComponent;



// WEBPACK FOOTER //
// ./src/components/result/result.component.js